import { Longhand } from "../longhand.js";
import Base from "./top.js";
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/left}
 * @internal
 */
export default Longhand.extend(Base);
//# sourceMappingURL=left.js.map